import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { timeConverter } from './../utils/NiceStrings'
import { getRumours, getTopRpList } from './../components';
import { listScenes } from '../components/sceneRequests';
import { getPlayerStoryList } from '../components/webContentRequests';
import SceneCard from './overview/SceneCard';
import { EventsCard, getEventData } from './overview/EventsCard';
import { getWhoList, WhoCard } from './overview/WhoCard';
import { SubmittedStoriesCard, getStoryList } from '../builder/overview/SubmittedStoriesCard';
import { getTopRpData, TopRPCard } from './overview/TopRPCard';

function WhatsGoingOn() {
    const [whosOnline, setWhosOnline] = useState([]);
    const [roleplayActivity, setRoleplayActivity] = useState([]);
    const [realmEvents, setRealmEvents] = useState([]);
    const [futureEvents, setFutureEvents] = useState([]);
    const [rumourMill, setRumourMill] = useState([]);
    const [scenes, setScenes] = useState([]);
    const [recentStories, setRecentStories] = useState([]);



    const getRumourMillCard = () => {
        return (
            //let oocplayers = [...new Set(whosOnline.filter(who => who.isooc === true).map(who => who.userName))];
            <Card className={"m-2 score-card-eom-overview"} >
                <Card.Header className={"going-on-header"}>
                    <Card.Title>The Midnight Rumour Mill</Card.Title>
                </Card.Header>
                <Card.Body>
                    {rumourMill.map((rumour, index) =>
                        <div key={index} className="divtext">
                            <h4>{rumour.subject}</h4><small>{timeConverter(rumour.cmdate)}</small>
                            <p>{rumour.rumour}</p>
                            <br></br>
                        </div>
                    )}


                </Card.Body>
            </Card>

        );
    }

    const getRoleplayStatusCard = () => {
        return (
            <Card className={"m-2 score-card-eom-overview"} >
                <Card.Header className={"going-on-header"}>
                    <Card.Title>Roleplay Status of Active Players</Card.Title>
                </Card.Header>
                <Card.Body>
                    {whosOnline.filter(who => who.rpstatus.length > 0).map(who =>
                        <p key={who.userName}>
                            <a key={who.userName} className="dryLink p-2" href={`/player/rpsheet/${who.userName}`}>
                                <strong>{who.userName}</strong> - {who.rpstatus}
                            </a>
                        </p>
                    )}
                </Card.Body>
            </Card>
        );
    }

    const getLatestRumours = async () => {
        let data = await getRumours();
        if (data.data === undefined)
            setRumourMill([]);
        else
            setRumourMill(data.data);
    }

    const getScenesFromServer = async e => {
        const data = await listScenes();
        if (data.result) {
            setScenes(data.scenes);
        } else {
            setScenes([]);
        }
    }

    useEffect(() => {
        getWhoList(setWhosOnline);
        getLatestRumours();
        getTopRpData(setRoleplayActivity);
        getEventData(setRealmEvents, setFutureEvents);
        getScenesFromServer();
        getStoryList( setRecentStories );

        const intervalRefreshFast = setInterval(() => {
            getWhoList(setWhosOnline);
        }, 60000);

        const intervalRefresh = setInterval(() => {
            //console.log('Refresh page')
            getWhoList();
            getLatestRumours();
            getTopRpData(setRoleplayActivity);
            getEventData(setRealmEvents, setFutureEvents);
        }, 300000);

        const intervalRefreshSlow = setInterval(() => {
            getScenesFromServer();
            getStoryList(setRecentStories);
        }, 600000);

        return () => {
            clearInterval(intervalRefresh);
            clearInterval(intervalRefreshSlow);
            clearInterval(intervalRefreshFast);
        }

    }, []);

    return (
        <div className="container container-wide" id="divMainContent">
            <div style={{
                display: 'flex', flex: 1, flexDirection: 'row', flexWrap: 'wrap', alignItems: "flex-start",
                justifyContent: "space-around"
            }}>
                <Row>
                    <Col xl={4}>
                        <WhoCard whosOnline={whosOnline} />
                        {getRoleplayStatusCard()}
                        <TopRPCard roleplayActivity={roleplayActivity}/>
                    </Col>
                    <Col xl={4}>
                        <SubmittedStoriesCard stories={recentStories} />
                        <EventsCard title={"Active"} mudEvents={realmEvents} />
                        <EventsCard title={"Future"} mudEvents={futureEvents} />
                    </Col>
                    <Col xl={4}>
                        <SceneCard scenes={scenes} />
                        {getRumourMillCard()}
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default WhatsGoingOn;